import { render } from "./WritingBoardTool.vue?vue&type=template&id=1a7beb9e&scoped=true&ts=true"
import script from "./WritingBoardTool.vue?vue&type=script&lang=ts"
export * from "./WritingBoardTool.vue?vue&type=script&lang=ts"

import "./WritingBoardTool.vue?vue&type=style&index=0&id=1a7beb9e&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a7beb9e"]])

export default __exports__